import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FooterLinksService {
  constructor() {}

  protected footerLinks: any = {
    'es-ES': [
      {
        title: 'Tienda',
        links: [
          {
            title: 'Encuentra el mejor cepillo para ti',
            link: 'mimejorcepillo',
          },
          {
            title: 'Cepillos eléctricos',
            link: 'cepillos-electricos',
          },
          {
            title: 'Recambios',
            link: 'recambios',
          },
          {
            title: 'Pasta dentífrica',
            link: 'otros-productos/pasta-dentifrica',
          },
          {
            title: 'Irrigadores',
            link: 'otros-productos/irrigadores',
          },
          {
            title: 'Cepillos eléctricos para niños',
            link: 'ninos/cepillos-electricos',
          },
          {
            title: 'Enjuague bucal',
            link: 'otros-productos/enjuague-bucal',
          },
          {
            title: 'Hilo dental',
            link: 'otros-productos/hilo-dental',
          },
        ],
      },
      {
        title: 'Aprender',
        links: [
          {
            title: '¿Por qué el cepillo de dientes eléctrico Oral-B?',
            link: 'salud-oral/por-que-oral-b/cepillos-de-dientes-electricos',
          },
          {
            title: '¿Por qué usar hilo dental Oral-B?',
            link: 'salud-oral/por-que-oral-b/hilo-dental',
          },
          {
            title: '¿Por qué usar pasta de dientes Oral-B?',
            link: 'salud-oral/por-que-oral-b/pasta-de-dientes',
          },
          {
            title: 'Mal aliento',
            link: 'salud-oral/condiciones/mal-aliento',
          },
          {
            title: 'Caries',
            link: 'salud-oral/condiciones/caries-dental',
          },
          {
            title: 'Sarro y placa',
            link: 'salud-oral/condiciones/sarro-y-placa',
          },
          {
            title: 'Esmalte dental',
            link: 'salud-oral/condiciones/salud-del-esmalte',
          },
          {
            title: 'Otros',
            link: 'salud-oral/condiciones/otras-condiciones-de-salud-bucal',
          },
        ],
      },
      {
        title: 'Sitios relacionados',
        links: [
          {
            title: 'Marcas P&G',
            link: 'https://es.pg.com/marcas-y-productos/',
          },
          {
            title: 'Oral-B Profesional',
            link: 'https://www.oralbprofessional.es/s/?language=es',
          },
          {
            title: 'Kukident',
            link: 'https://kukident.es/es-es',
          },
          {
            title: 'Salud Oral',
            link: 'https://www.oralb.es/es-es/salud-oral',
          },
          {
            title: 'Próxima a ti',
            link: 'https://www.proximaati.com',
          },
          {
            title: 'Braun',
            link: 'https://es.braun.com/es-es',
          },
        ],
      },
      {
        title: 'Contacta con nosotros',
        links: [
          {
            title: 'Atención al cliente',
            link: 'https://www.oralb.es/es-es/customer-care',
          },
          {
            title: '¿Preguntas?',
            link: 'faq',
          },
          {
            title: 'Servicio Oral-B',
            link: 'https://www.service.oralb.com/es/es/',
          },
          {
            title: '30 días de prueba gratis',
            link: '30-dias-de-prueba-gratis',
          },
          {
            title: 'Active su garantía',
            link: 'https://www.oralb.es/es-es/salud-oral/por-que-oral-b/preguntas/como-puedo-registrarme-para-obtener-la-garantia-ampliada-de-oral-b',
          },
        ],
      },
    ],
    'fr-FR': [
      {
        title: 'Boutique',
        links: [
          {
            title: 'Trouvez la brosse pour vous',
            link: 'MaMeilleureBrosse',
          },
          {
            title: 'Brosses à dents électriques',
            link: 'brosses-a-dents-electriques',
          },
          {
            title: 'Brossettes de rechange',
            link: 'brossettes-de-rechange',
          },
          {
            title: 'Dentifrice',
            link: 'produits-dentaires/dentifrice',
          },
          {
            title: 'Hydropulseurs',
            link: 'plus-de-produits/hydropulseurs',
          },
          {
            title: 'Hydropulseurs & combine dentaire',
            link: 'produits-dentaires/benefices-hydropulseur-et-combine-dentaire',
          },
          {
            title: 'Brosses à dents enfant',
            link: 'enfants/brosses-a-dents-electriques',
          },
          {
            title: 'Bains de bouche',
            link: 'bains-de-bouche',
          },
          {
            title: 'Routine dentaire',
            link: 'plus-de-produits/routine-dentaire',
          },
          {
            title: 'Fil Dentaire',
            link: 'produits-dentaires/fil-dentaire',
          },
        ],
      },
      {
        title: 'Apprendre',
        links: [
          {
            title: 'Bienfait brosse a dent electrique',
            link: 'produits-dentaires/bienfait-brosse-a-dent-electrique',
          },
          {
            title: 'Pourquoi les brosses à dents électriques Oral-B',
            link: 'sante-bucco-dentaire/quelle-brosse-a-dents-electrique-choisir-oral-b/comment-se-brosser-les-dents-correctement',
          },
          {
            title: 'Pourquoi choisir le dentifrice Oral-B',
            link: 'sante-bucco-dentaire/pourquoi-choisir-oral-b/dentifrices',
          },
          {
            title: 'Pourquoi utiliser du fil dentaire Oral-B',
            link: 'sante-bucco-dentaire/soie-dentaire',
          },
          {
            title: 'Pourquoi choisir le bain de bouche Oral-B',
            link: 'sante-bucco-dentaire/bouche-saine',
          },
          {
            title: 'Maladies des gencives (infection, irritation etc.)',
            link: 'sante-bucco-dentaire/maladies-problemes-dentaires/soin-des-gencives',
          },
          {
            title: 'Mauvaise haleine',
            link: 'sante-bucco-dentaire/maladies-problemes-dentaires/mauvaise-haleine',
          },
          {
            title: 'Caries et érosion dentaire',
            link: 'sante-bucco-dentaire/maladies-problemes-dentaires/caries-et-erosion-dentaire',
          },
          {
            title: 'Plaque dentaire et tartre',
            link: 'sante-bucco-dentaire/maladies-problemes-dentaires/plaque-dentaire-tartre',
          },
          {
            title: 'Sensibilité',
            link: 'sante-bucco-dentaire/maladies-problemes-dentaires/sensibilite-des-dents',
          },
          {
            title: 'Email dentaire',
            link: 'sante-bucco-dentaire/maladies-problemes-dentaires/email-dentaire',
          },
          {
            title: 'Blancheur',
            link: 'sante-bucco-dentaire/maladies-problemes-dentaires/blanchiment-dentaire',
          },
          {
            title: 'Soin dentaire enfant',
            link: 'sante-bucco-dentaire/sante-dentaire-par-age/enfants',
          },
        ],
      },
      {
        title: 'Sites connexes',
        links: [
          {
            title: 'Marques P&G',
            link: 'https://fr.pg.com/marques-et-produits/',
          },
          {
            title: 'Oral-B Professional',
            link: 'https://www.oralbprofessional.fr/s/?language=fr',
          },
          {
            title: 'Fixodent',
            link: 'https://www.fixodent.fr/fr-fr',
          },
          {
            title: 'Envie de Plus',
            link: 'https://www.enviedeplus.com',
          },
          {
            title: 'Braun',
            link: 'https://fr.braun.com/fr-fr',
          },
        ],
      },
      {
        title: 'Notre ambition',
        links: [
          {
            title: 'Recyclage (y compris les équipements électriques et électroniques)',
            link: 'docs/cgv#recycling',
          },
        ],
      },
      {
        title: 'Contactez-nous',
        links: [
          {
            title: 'Service Client',
            link: 'https://www.oralb.fr/fr-fr/customer-care',
          },
          {
            title: 'Questions?',
            link: 'faq',
          },
          {
            title: 'Service',
            link: 'https://www.service.oralb.com/fr/fr/',
          },
          {
            title: '30 jours, Satisfait ou remboursé',
            link: 'https://www.satisfaitourembourse-oralb.fr/',
          },
          {
            title: 'Activez votre garantie',
            link: 'account',
          },
        ],
      },
    ],
  };

  public getFooterLinks(): any {
    return this.footerLinks;
  }
}
